<div class="monitoring-filter-container">
  <form [formGroup]="form" class="filter-form">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Cliente</mat-label>
      <input
        matInput
        formControlName="organization"
        [matAutocomplete]="autoOrg"
        placeholder="Digite o nome do cliente"
      />
      @if (form.value.organization != undefined) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="clearOrganizationField()"
          [attr.aria-label]="'Limpar cliente'"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      <mat-autocomplete
        #autoOrg="matAutocomplete"
        [displayWith]="displayOrganizationName"
      >
        <mat-option [value]="'__ALL__'">Todos</mat-option>
        <mat-option [value]="'Geoambiente'">Geoambiente</mat-option>
        @for (org of filteredOrganizations; track org.id) {
          <mat-option [value]="org">{{ org.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Safra</mat-label>
      <mat-select formControlName="safra">
        <mat-option value="">Todas</mat-option>
        @for (cropPeriod of cropPeriods; track $index) {
          <mat-option [value]="cropPeriod">{{ cropPeriod }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Cultura</mat-label>
      <mat-select formControlName="cultura">
        <mat-option value="">Todas</mat-option>
        @for (cropCulture of cropCultures; track $index) {
          <mat-option [value]="cropCulture">{{
            cropCulture.description
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="filter-actions">
      <button
        mat-icon-button
        type="button"
        (click)="onApplyFilter()"
        class="apply-button"
        matTooltip="Aplicar filtros"
      >
        <mat-icon>search</mat-icon>
      </button>

      <button
        mat-icon-button
        type="button"
        (click)="onClearFilter()"
        class="clear-button"
        matTooltip="Limpar filtros"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </form>
</div>
